import {copilot} from '@cl/shared';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import creativesLibraryContext from 'common/src/modules/creatives/copilot/context/creativesLibraryContext';
import {CLStore} from 'common/src/redux/store';

function initializeCreativesUiContexts(store: CLStore) {
  copilot.uiContexts.registerUiContexts(BreadcrumbName.CreativesLibrary, {
    description:
      'The creatives library lists all published creatives in the account with filtering and search.',
    contexts: [creativesLibraryContext(store)],
  });
}

export default initializeCreativesUiContexts;
